import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume14 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="flex w-full mx-auto my-5 bg-white shadow-lg border border-gray-300 overflow-hidden" ref={resumeRef}>
        <div className="bg-[#f0f4fa] p-5 w-1/3 text-center">
          <div className="mb-5">
            <img
              className="w-[150px] h-[150px] rounded-full object-cover mx-auto"
              src={ResumeStore?.resumeBuilder.profile || 'https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww'}
              alt="Profile Picture"
            />
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold mb-2">Contact</h2>
            <p>{ResumeStore?.resumeBuilder.personalDetails.phone || '+1 212 06 06 060'}</p>
            <p>{ResumeStore?.resumeBuilder.personalDetails.email || 'name@email.com'}</p>
            <p>{ResumeStore?.resumeBuilder.personalDetails.city || 'LA, California'}</p>
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold mb-2">Languages</h2>
            <p>English</p>
            <p>French</p>
            <p>Italian</p>
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold mb-2">Skills</h2>
            <ul className="list-none p-0">
              {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
                <li key={index} className="text-sm mb-2">{skill}</li>
              ))}
            </ul>
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold mb-2">Interests</h2>
            <ul className="list-none p-0">
              {ResumeStore?.resumeBuilder.hobbies.map((hobby, index) => (
                <li key={index} className="text-sm mb-2">{hobby}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="p-5 w-2/3">
          <div className="text-center mb-5">
            <h1 className="text-4xl font-bold mb-2">{ResumeStore?.resumeBuilder.personalDetails.firstName} {ResumeStore?.resumeBuilder.personalDetails.lastName}</h1>
            <h2 className="text-xl font-semibold text-gray-600 mb-5">{ResumeStore?.resumeBuilder.personalDetails.jobTitle || 'Internship / Student Job'}</h2>
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold mb-2 border-b-2 border-gray-400 pb-1">Career Objective</h2>
            <p>{ResumeStore?.resumeBuilder.profileSummary || 'Passionate and enthusiastic 3rd year student with excellent interpersonal skills and a high interest in foreign languages. Looking for a student job as a hostess in a hotel or a catering company.'}</p>
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold mb-2 border-b-2 border-gray-400 pb-1">Education</h2>
            {ResumeStore?.resumeBuilder.education.map((edu, index) => (
              <div key={index} className="mb-4">
                <h3 className="text-md font-semibold">{edu.degree || 'Hospitality & Tourism, B.S.'}</h3>
                <p className="text-sm text-gray-600">{edu.school || 'California State University'} | {edu.startDate} – {edu.endDate}</p>
                <ul className="list-disc pl-5">
                  <li>F&B management</li>
                  <li>Travel and tourism</li>
                  <li>Revenue management</li>
                  <li>Law and ethics</li>
                </ul>
              </div>
            ))}
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold mb-2 border-b-2 border-gray-400 pb-1">Professional Experience</h2>
            {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
              <div key={index} className="mb-4">
                <h3 className="text-md font-semibold">{job.jobTitle || 'Catering Services'}</h3>
                <p className="text-sm text-gray-600">{job.company || 'Cater2U, LA'} | {job.startDate}</p>
                <ul className="list-disc pl-5">
                  <li>Taking inventory</li>
                  <li>Assisting in kitchen duties</li>
                  <li>Serving event attendees</li>
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  ));
}

export default Resume14;
